<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="fitnessReservation.id === null">{{ 'NEWFITNESSRESERVATION' | translate }}</span>
            <span *ngIf="fitnessReservation.id !== null">{{ 'EDITFITNESSRESERVATION' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="fitnessReservationForm" id="fitnessReservationForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="fitnessReservationForm" >
            <input type="hidden" name="id" id="fitnessReservationId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-alarm-clock"></i>
                    </span>
                    <span class="p-float-label">
                      <p-calendar inputId="fitnessReservationAttendingTime" formControlName="attendingTime" [showTime]="true" hourFormat="24" [showIcon]="true" [yearNavigator]="true" [monthNavigator]="true" [required]="false" yearRange="1900:2030" [stepHour]="1" [stepMinute]="15" [stepSecond]="0"></p-calendar>
                      <label for="fitnessReservationAttendingTime" class="">{{ 'ATTENDINGTIME' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-timer"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="fitnessReservationAttendingDuration" formControlName="attendingDuration" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="fitnessReservationAttendingDuration" class="">{{ 'ATTENDINGDURATION' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="fitnessReservationFitnessSessionId" [autoDisplayFirst]="false" formControlName="fitnessSession" [options]="fitnessReservationsColumnsService.fitnessSessions" optionValue="id" optionLabel="label_" [required]="true" [filter]="true"></p-dropdown>
                      <label for="fitnessReservationFitnessSessionId" class="req">{{ 'FITNESSSESSION' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="fitnessReservationForm.controls['fitnessSession'].invalid && (fitnessReservationForm.controls['fitnessSession'].dirty || fitnessReservationForm.controls['fitnessSession'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessReservationForm.controls['fitnessSession'].errors !== null">
                  <div *ngIf="fitnessReservationForm.controls['fitnessSession'].errors.required">
                   {{ 'FITNESSSESSIONREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="fitnessReservationMemberId" [autoDisplayFirst]="false" formControlName="member" [options]="fitnessReservationsColumnsService.members" optionValue="id" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="fitnessReservationMemberId" class="req">{{ 'MEMBER' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="fitnessReservationForm.controls['member'].invalid && (fitnessReservationForm.controls['member'].dirty || fitnessReservationForm.controls['member'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessReservationForm.controls['member'].errors !== null">
                  <div *ngIf="fitnessReservationForm.controls['member'].errors.required">
                   {{ 'MEMBERREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="fitnessReservationIsConfirmed" formControlName="isConfirmed" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="fitnessReservationIsConfirmed" class="p-d-inline-block p-ml-2 req">{{ 'ISCONFIRMED' | translate }}</label>
                </div>
                <div *ngIf="fitnessReservationForm.controls['isConfirmed'].invalid && (fitnessReservationForm.controls['isConfirmed'].dirty || fitnessReservationForm.controls['isConfirmed'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessReservationForm.controls['isConfirmed'].errors !== null">
                  <div *ngIf="fitnessReservationForm.controls['isConfirmed'].errors.required">
                   {{ 'ISCONFIRMEDREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKFITNESSRESERVATIONS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="fitnessReservation.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!fitnessReservationForm.valid || disableSubmit"> <!--  [disabled]="fitnessReservationForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!fitnessReservationForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

